import { Injectable } from '@angular/core';
import { ConfigService } from '@klickdata/core/config';
import { RequestBuilderService } from '@klickdata/core/http/src/request/request-builder.service';
import { Observable, map } from 'rxjs';
import { CustomTab, CustomTabData } from './custom-tab.model';

@Injectable({
    providedIn: 'root',
})
export class CustomTabService {
    protected customTabUrl: string;
    protected user_id: Observable<number>;
    protected customer_id: Observable<number>;

    constructor(
        protected config: ConfigService,
        protected builder: RequestBuilderService // protected auth: AuthService
    ) {
        this.customTabUrl = `${config.config.apiUrl}custom-tabs`;
        // this.user_id = this.auth.getUser().pipe(
        //     first(),
        //     map((user) => user.id)
        // );

        // this.customer_id = this.auth.getCustomer().pipe(
        //     first(),
        //     map((customer) => customer.id)
        // );
    }

    public addCustomTab(tab: CustomTabData): Observable<CustomTab> {
        return this.builder
            .post<CustomTab>(`${this.customTabUrl}`, tab)
            .request()
            .pipe(map((res) => this.mapCustomTab(res.data)));
    }
    public duplicateCustomTab(id: number): Observable<CustomTab> {
        return this.builder
            .post<CustomTabData>(`${this.customTabUrl}/${id}/duplicate`, null)
            .request()
            .pipe(map((res) => this.mapCustomTab(res.data)));
    }

    public deleteCustomTab(id: number): Observable<{ success: boolean }> {
        const req = this.builder.delete<{ success: boolean }>(`${this.customTabUrl}/${id}`);
        return req.request().pipe(map((res) => res.data));
    }

    public delete(id: number): Observable<{ success: boolean }> {
        const req = this.builder.delete<{ success: boolean }>(`${this.customTabUrl}/${id}`);
        return req.request().pipe(map((res) => res.data));
    }

    public getCustomTabTypes(): Observable<{ type: string; options: string[] }[]> {
        return this.builder
            .get<{ type: string; options: string[] }[]>(`${this.customTabUrl}/types`)
            .request()
            .pipe(map((res) => res.data));
    }
    public restore(ids: number | number[]): Observable<CustomTab | CustomTab[]> {
        return this.builder
            .put<CustomTab | CustomTab[]>(`${this.customTabUrl}/${ids}/restore`, null)
            .request()
            .pipe(
                map((res) =>
                    Array.isArray(res.data)
                        ? res.data.map((res) => this.mapCustomTab(res))
                        : this.mapCustomTab(res.data)
                )
            );
    }
    public getCustomTabs(): Observable<CustomTab[]> {
        return this.builder
            .get<CustomTab[]>(`${this.customTabUrl}`)
            .request()
            .pipe(map((res) => res.data));
    }

    public updateCustomTab(tab: CustomTabData): Observable<CustomTab> {
        return this.builder
            .put<CustomTab>(`${this.customTabUrl}/${tab.id}`, tab)
            .request()
            .pipe(map((res) => this.mapCustomTab(res.data)));
    }

    protected mapCustomTab(data: CustomTabData): CustomTab {
        return new CustomTab(data);
    }
}
